import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { RevealText, Reveal } from "@/components/RevealText";
import { getBlog } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBlog().then(setPosts).finally(() => setLoading(false));
  }, []);

  return (
    <div className="pt-32 md:pt-44" data-testid="blog-page">
      <section className="max-w-[1600px] mx-auto px-6 md:px-10 pb-16 md:pb-24 border-b border-white/10">
        <p className="font-mono text-xs tracking-[0.3em] uppercase text-white/40 mb-8 flex items-center gap-3">
          <span className="w-8 h-px bg-[color:var(--accent)]" /> The Journal
        </p>
        <h1 className="font-display text-6xl md:text-[9vw] uppercase tracking-tighter leading-[0.82]">
          <RevealText lines={["Notes on"]} />
          <span className="block text-white/25"><RevealText lines={["the future."]} delay={0.12} /></span>
        </h1>
        <p className="font-mono text-sm md:text-base text-white/55 max-w-xl mt-8">
          Ideas on web engineering, software craft, Generative AI and growth — written by the Liinex team.
        </p>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-10 py-16 md:py-24">
        {loading ? (
          <p className="font-mono text-white/40">Loading…</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={(i % 2) * 0.1}>
                <Link to={`/blog/${p.slug}`} className="group block border border-white/10 hover:border-white/30 transition-colors h-full" data-testid={`blog-card-${p.slug}`}>
                  <div className="aspect-[16/9] overflow-hidden border-b border-white/10">
                    <img src={p.cover} alt={p.title} className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                  </div>
                  <div className="p-8 md:p-10">
                    <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.2em] uppercase text-white/40 mb-5">
                      <span className="text-[color:var(--accent)]">{p.category}</span><span>/</span><span>{p.date}</span><span>/</span><span>{p.read}</span>
                    </div>
                    <h2 className="font-display text-3xl md:text-4xl uppercase tracking-tight leading-tight mb-4">{p.title}</h2>
                    <p className="font-mono text-sm text-white/55 mb-6">{p.excerpt}</p>
                    <span className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-white/70 group-hover:text-[color:var(--accent)] transition-colors">
                      Read <ArrowUpRight size={14} className="group-hover:rotate-45 transition-transform" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
